/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCorrectionSalesInvoiceDto
 */
export interface CreateCorrectionSalesInvoiceDto {
    /**
     * 
     * @type {string}
     * @memberof CreateCorrectionSalesInvoiceDto
     */
    parentId: string;
}

/**
 * Check if a given object implements the CreateCorrectionSalesInvoiceDto interface.
 */
export function instanceOfCreateCorrectionSalesInvoiceDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "parentId" in value;

    return isInstance;
}

export function CreateCorrectionSalesInvoiceDtoFromJSON(json: any): CreateCorrectionSalesInvoiceDto {
    return CreateCorrectionSalesInvoiceDtoFromJSONTyped(json, false);
}

export function CreateCorrectionSalesInvoiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCorrectionSalesInvoiceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'parentId': json['parentId'],
    };
}

export function CreateCorrectionSalesInvoiceDtoToJSON(value?: CreateCorrectionSalesInvoiceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'parentId': value.parentId,
    };
}

